"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : EquipmentLog.js
* Description : Ce fichier contient la définition du composant EquipmentLog 
*               Ce composant liste tous les logs d'un produit client
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ /* Hook */ /**
* EquipmentLog : ce composant liste tous les logs d'un produit client
*                un lien permet de sauvegarder les logs sous le format CSV
*
* Type : composant 
*
* Parametres : 
*  None
*/
function EquipmentLog(_ref) {
  var equipment_id = _ref.equipment_id,
    date = _ref.date,
    statusLogsProp = _ref.statusLogs,
    logsProp = _ref.logs,
    levelsProp = _ref.levels,
    eventsProp = _ref.events;
  // Define useState hooks
  var _useState = (0, _react.useState)(statusLogsProp || 0),
    _useState2 = _slicedToArray(_useState, 2),
    statusLogs = _useState2[0],
    setStatusLogs = _useState2[1];
  var _useState3 = (0, _react.useState)(logsProp || []),
    _useState4 = _slicedToArray(_useState3, 2),
    logs = _useState4[0],
    setLogs = _useState4[1];
  var _useState5 = (0, _react.useState)(logsProp || []),
    _useState6 = _slicedToArray(_useState5, 2),
    filteredLogs = _useState6[0],
    setFilteredLogs = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDataLoading = _useState8[0],
    setDataLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(levelsProp || []),
    _useState0 = _slicedToArray(_useState9, 2),
    criticityList = _useState0[0],
    setCriticityList = _useState0[1];
  var _useState1 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedCriticity = _useState10[0],
    setSelectedCriticity = _useState10[1];
  var _useState11 = (0, _react.useState)(eventsProp || []),
    _useState12 = _slicedToArray(_useState11, 2),
    eventList = _useState12[0],
    setEventList = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedEvent = _useState14[0],
    setSelectedEvent = _useState14[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    applicationName = _useApi.applicationName;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, url_logs, resLog, dataLog;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Retrieve log list
            if (applicationName === 'BOXIBRAIN') {
              // log maintenance
              url_logs = path + "/api/eq-loma/latest/?equipment_id=" + equipment_id + "&datetime=" + date;
            } else {
              // log user
              url_logs = path + "/api/eq-lous/latest/?equipment_id=" + equipment_id + "&datetime=" + date;
            }
            _context.n = 1;
            return fetch(url_logs, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 1:
            resLog = _context.v;
            _context.n = 2;
            return resLog.json();
          case 2:
            dataLog = _context.v;
            setStatusLogs(resLog["status"]);
            setLogs(dataLog);
            // Dataloading
            setDataLoading(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveData.apply(this, arguments);
  }
  var handleFiles = function handleFiles(event) {
    event.preventDefault();
    sendRequestToGenerateFile();
  };
  function sendRequestToGenerateFile() {
    return _sendRequestToGenerateFile.apply(this, arguments);
  }
  function _sendRequestToGenerateFile() {
    _sendRequestToGenerateFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var token, url_logs, response, blob, url, link, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Create and download csv file
            _context2.p = 1;
            if (applicationName === 'BOXIBRAIN') {
              // log maintenance
              url_logs = path + "/api/eq-loma/save-csv/?equipment_id=" + equipment_id;
            } else {
              // log user
              url_logs = path + "/api/eq-lous/save-csv/?equipment_id=" + equipment_id;
            }
            _context2.n = 2;
            return fetch(url_logs, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 2:
            response = _context2.v;
            if (response.ok) {
              _context2.n = 3;
              break;
            }
            throw new Error('Erreur pendant le téléchargement');
          case 3:
            _context2.n = 4;
            return response.blob();
          case 4:
            blob = _context2.v;
            url = window.URL.createObjectURL(blob);
            link = document.createElement('a');
            link.href = url;
            if (applicationName === 'BOXIBRAIN') {
              link.download = 'maintenance_logs.csv'; // Nom du fichier proposé
            } else {
              link.download = 'logs.csv'; // Nom du fichier proposé
            }
            document.body.appendChild(link);
            link.click();

            // Nettoyage
            link.remove();
            window.URL.revokeObjectURL(url);
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t = _context2.v;
            console.error('Erreur :', _t);
            alert('Impossible de télécharger le fichier');
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 5]]);
    }));
    return _sendRequestToGenerateFile.apply(this, arguments);
  }
  function retrieveFilters() {
    // Retrieve criticity list filter
    var criticities = [];
    var criticitiesValues = [];
    var indexC = 0;
    var _iterator = _createForOfIteratorHelper(logs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var log = _step.value;
        if (!criticitiesValues.includes(log["level"])) {
          indexC = indexC + 1;
          criticitiesValues.push(log["level"]);
          criticities.push({
            'id': indexC,
            'name': log["level"]
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setCriticityList(criticities);
    // Retrieve event list filter
    var events = [];
    var eventsValues = [];
    var indexE = 0;
    var _iterator2 = _createForOfIteratorHelper(logs),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _log = _step2.value;
        if (!eventsValues.includes(_log["message"])) {
          indexE = indexE + 1;
          eventsValues.push(_log["message"]);
          events.push({
            'id': indexE,
            'name': _log["message"]
          });
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    setEventList(events);
  }
  function updateFilteredLogs() {
    // Filtering criticity
    if (Number(selectedCriticity) > 0 && Number(selectedEvent) === 0) {
      setFilteredLogs(logs.filter(function (log) {
        return log["level"] === criticityList.find(function (version) {
          return version.id === Number(selectedCriticity);
        })['name'];
      }));
    }
    // Filtering event
    else if (Number(selectedCriticity) === 0 && Number(selectedEvent) > 0) {
      setFilteredLogs(logs.filter(function (log) {
        return log["message"].includes(eventList.find(function (version) {
          return version.id === Number(selectedEvent);
        })['name']);
      }));
    }
    // Filtering criticity and event
    else if (Number(selectedCriticity) > 0 && Number(selectedEvent) > 0) {
      setFilteredLogs(logs.filter(function (log) {
        return log["level"] === criticityList.find(function (version) {
          return version.id === Number(selectedCriticity);
        })['name'] && log["message"].includes(eventList.find(function (version) {
          return version.id === Number(selectedEvent);
        })['name']);
      }));
    }
    // No filter
    else {
      setFilteredLogs(logs);
    }
  }

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      setDataLoading(true);
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);
  (0, _react.useEffect)(function () {
    retrieveFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logs]);
  (0, _react.useEffect)(function () {
    updateFilteredLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [criticityList, selectedCriticity, selectedEvent]);

  // Render component
  return isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: "Chargement des donn\xE9es"
    })
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: statusLogs === 200 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: screenWidth > 1000 ? 'grid-1-1 justify-center' : null,
        children: [applicationName === "BOXIBRAIN" ? screenWidth > 600 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: 'grid-1-2-2 justify-center',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Filtres : "
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
            labelText: "Criticit\xE9",
            choices: criticityList,
            choiceParam: 'name',
            selectedItem: selectedCriticity,
            setSelectedItem: setSelectedCriticity,
            subfilter: false
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
            labelText: "Type d'\xE9v\xE8nement",
            choices: eventList,
            choiceParam: 'name',
            selectedItem: selectedEvent,
            setSelectedItem: setSelectedEvent,
            subfilter: false
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Filtres : "
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: screenWidth > 400 ? 'grid-1-1 justify-center' : null,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
              labelText: "Criticit\xE9",
              choices: criticityList,
              choiceParam: 'name',
              selectedItem: selectedCriticity,
              setSelectedItem: setSelectedCriticity,
              subfilter: false
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
              labelText: "Type d'\xE9v\xE8nement",
              choices: eventList,
              choiceParam: 'name',
              selectedItem: selectedEvent,
              setSelectedItem: setSelectedEvent,
              subfilter: false
            })]
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: screenWidth > 600 ? 'grid-1-2-2 justify-center' : 'grid-1-2 justify-center',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Filtres : "
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
            labelText: "Type d'evenement",
            choices: eventList,
            choiceParam: 'name',
            selectedItem: selectedEvent,
            setSelectedItem: setSelectedEvent,
            subfilter: false
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: screenWidth > 1000 ? 'flex-row justify-end' : 'flex-row justify-start',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            onClick: handleFiles,
            className: "sublink link-border clickable",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-text",
              children: "Sauvegarder en CSV"
            })
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "margin-bottom margin-top",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableContainer["default"], {
          component: _Paper["default"],
          className: "margin-bottom margin-top table-border",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Table["default"], {
            sx: {
              minWidth: 280
            },
            size: "small",
            "aria-label": "a dense table",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableHead["default"], {
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                    className: "table-label",
                    children: "Date"
                  })
                }), applicationName === "BOXIBRAIN" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                    className: "table-label",
                    children: "Criticit\xE9"
                  })
                }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                    className: "table-label",
                    children: "Message"
                  })
                }), applicationName === "BOXIBRAIN" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                    className: "table-label",
                    children: "Provenance"
                  })
                }) : null]
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableBody["default"], {
              children: filteredLogs && filteredLogs.length !== 0 ? filteredLogs.map(function (log) {
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TableRow["default"], {
                  sx: {
                    '&:last-child td, &:last-child th': {
                      border: 0
                    }
                  },
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    component: "th",
                    scope: "row",
                    children: log['datetime']
                  }), applicationName === "BOXIBRAIN" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: log['level']
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: log['message']
                  }), applicationName === "BOXIBRAIN" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableCell["default"], {
                    children: log['transmitter']
                  }) : null]
                }, log.id);
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                children: "Aucun log ne correponds au filtrage s\xE9lectionn\xE9."
              })
            })]
          })
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: "Produit client non disponible !"
      })
    })
  });
}
var _default = exports["default"] = EquipmentLog;